import { statusRecipe } from '../constants/recipe-status.constant';

export const hideRejectButton = (status) => {
	if (status === statusRecipe.rejected) {
		return { display: 'none' };
	}
	return null;
};
